import { IIconProps } from "../types"

export default function IconUL3(props: IIconProps) {
  const width = props.size || props.width || 66
  const height = props.size || props.height || 103
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 66 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.0895 1.24126C38.2595 0.811265 35.4595 0.551265 33.2095 0.941265C30.9695 1.33126 29.2795 2.38126 27.7095 3.52126C26.1495 4.65126 24.7195 5.89126 22.0495 10.3513C19.3795 14.8113 15.4695 22.4913 11.9895 29.9813C8.50946 37.4713 5.44946 44.7613 3.53946 50.4613C1.61946 56.1513 0.859462 60.2513 0.759462 63.1513C0.669462 66.0513 1.22946 67.7413 2.09946 69.9513C2.96946 72.1713 4.14946 74.9013 6.67946 78.9113C9.21946 82.9113 13.1295 88.1813 16.4195 92.1213C19.7095 96.0613 22.3695 98.6613 24.7495 100.131C27.1295 101.601 29.2095 101.921 31.7195 101.631C34.2195 101.331 37.1495 100.421 41.5495 98.2113C45.9395 96.0013 51.7995 92.4813 55.4795 89.9113C59.1595 87.3413 60.6595 85.7113 61.7895 83.4613C62.9295 81.2213 63.7195 78.3513 64.0695 74.8013C64.4295 71.2613 64.3695 67.0213 63.9095 61.8213C63.4595 56.6113 62.6095 50.4213 60.9195 42.1913C59.2195 33.9513 56.6895 23.6613 54.6695 16.7613C52.6495 9.86126 51.1495 6.35126 48.9695 4.30126C46.7895 2.25126 43.9195 1.66126 41.0895 1.24126Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
